import { useEffect, useReducer } from 'react';
import { hysteriFetch } from 'hysterics';

const fetchVehicleViews = hysteriFetch('ws-vehicle-title-views');

const vehicleViewsRequestReducer = (state, action) => {
	switch (action.type) {
		case 'VIEWS_REQUEST_SUCCESS':
			return {
				...state,
				isLoading: false,
				hasViewsData: true,
				numberOfViews: action.payload
			};
		case 'VIEWS_REQUEST_FAILURE':
			return {
				...state,
				isLoading: false,
				hasError: true
			};
		case 'VIEWS_REQUEST_SKIPPED':
		default:
			return {
				...state,
				isLoading: false
			};
	}
};

const useVehicleViews = (vin, timeFrame, shouldRequest) => {
	const initialState = {
		isLoading: true,
		hasError: false,
		hasViewsData: false,
		numberOfViews: 0
	};

	const [state, dispatch] = useReducer(
		vehicleViewsRequestReducer,
		initialState
	);

	useEffect(() => {
		let shouldDispatch = true;

		(async () => {
			if (shouldRequest && vin && timeFrame) {
				try {
					const response = await fetchVehicleViews(
						'/api/widget/ws-vehicle-title/getVehicleViews',
						{
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								parameters: { vin, timeframe: timeFrame }
							})
						}
					);
					if (shouldDispatch) {
						const hasValidViewCount =
							response?.DDC || response?.DDC === 0;
						if (hasValidViewCount) {
							dispatch({
								type: 'VIEWS_REQUEST_SUCCESS',
								payload: response.DDC
							});
						} else {
							dispatch({
								type: 'VIEWS_REQUEST_FAILURE'
							});
						}
					}
				} catch (err) {
					if (shouldDispatch) {
						dispatch({
							type: 'VIEWS_REQUEST_FAILURE'
						});
					}
				}
			} else if (shouldDispatch) {
				dispatch({
					type: 'VIEWS_REQUEST_SKIPPED'
				});
			}
		})();

		// Prevent dispatch after component unmounts
		return () => {
			shouldDispatch = false;
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return state;
};

export default useVehicleViews;
